import React from "react";
import { observer } from "mobx-react";
import { WeaCheckbox } from "ecCom";

@observer
export default class CheckboxItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c, type } = this.props;
    return (
      <WeaCheckbox
        ecId={`${this.props.ecId}_WeaCheckbox@zgt4va`}
        {...bindObj.bind()}
        display={type === "switch" ? "switch" : "normal"}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/CheckboxItem.js